import React from "react";
import { Button, useTheme } from "@material-ui/core";
import { alpha, makeStyles } from "@material-ui/core/styles";
import classnames from "classnames";
import { SimpleModal } from "../SimpleModal";
export var useStyles = makeStyles({
    keepBtn: {
        backgroundColor: "transparent",
        color: "".concat(function (props) { return alpha(props.theme.palette.text.primary, 0.6); }),
        borderColor: "#6b6e75;",
        borderWidth: "1px",
        borderStyle: "solid",
        marginRight: "10px"
    },
    cancelBtn: {
        backgroundColor: "#46191e",
        color: "#ed5465"
    },
    button: {
        lineHeight: 1.25,
        fontSize: "\"".concat(function (props) { return props.theme.typography.pxToRem(16); }, "\""),
        fontWeight: 900,
        padding: "13px 18px 15px"
    }
});
var CommentDeleteModal = function (_a) {
    var modalOpen = _a.modalOpen, setModalOpen = _a.setModalOpen, onConfirm = _a.onConfirm, text = _a.text, _b = _a.isDeleteLoading, isDeleteLoading = _b === void 0 ? false : _b;
    var theme = useTheme();
    var classes = useStyles();
    var onClose = function () {
        if (!isDeleteLoading) {
            setModalOpen(false);
        }
    };
    return (React.createElement(SimpleModal, { theme: theme, open: modalOpen, onClose: onClose, text: text, footer: React.createElement(React.Fragment, null,
            React.createElement(Button, { className: classnames(classes.keepBtn, classes.button), size: "medium", onClick: onClose }, "Cancel"),
            React.createElement(Button, { className: classnames(classes.cancelBtn, classes.button), size: "medium", onClick: function () { return onConfirm(); } }, "Delete Comment")) }));
};
export default CommentDeleteModal;
//# sourceMappingURL=CommentDeleteModal.js.map